export const PROJECT_LOGOS = {
  platemind: { src: "/assets/logos/platemind.png", h: "max-h-16 max-w-[70%]", hLg: "max-h-28 max-w-[75%]" },
  onconourish: { src: "/assets/logos/onconourish.png", h: "max-h-16 max-w-[72%]", hLg: "max-h-28 max-w-[78%]" },
  "sito-health": { src: "/assets/logos/sito.png", h: "max-h-16 max-w-[62%]", hLg: "max-h-28 max-w-[68%]" },
  "lana-clinical": { src: "/assets/logos/lana.png", h: "max-h-14 max-w-[58%]", hLg: "max-h-24 max-w-[62%]" },
  "balance-clinic": { src: "/assets/logos/balance.png", h: "max-h-24 max-w-[80%]", hLg: "max-h-32 max-w-[80%]" },
  akaani: { src: "/assets/logos/akaani.png", h: "max-h-12 max-w-[52%]", hLg: "max-h-20 max-w-[58%]" },
  qilo: { src: "/assets/logos/qilo.png", h: "max-h-20 max-w-[60%]", hLg: "max-h-28 max-w-[64%]" },
  pocketfood: { src: "/assets/logos/pocketfood.png", h: "max-h-14 max-w-[58%]", hLg: "max-h-24 max-w-[62%]" },
  fitprep: { src: "/assets/logos/fitprep.png", h: "max-h-14 max-w-[66%]", hLg: "max-h-24 max-w-[70%]" },
  "healthy-cooking-masterclass": { src: "/assets/logos/hcm.png", bg: "#264122", h: "max-h-24 max-w-[62%]", hLg: "max-h-32 max-w-[64%]" },
  chronicare: { src: "/assets/logos/chronicare.png", bg: "#454649", h: "max-h-24 max-w-[52%]", hLg: "max-h-32 max-w-[54%]" },
};

export const COLLABORATOR_LOGOS = {
  Akaani: { src: "/assets/logos/akaani.png", cls: "max-h-10" },
  Qilo: { src: "/assets/logos/qilo.png", cls: "max-h-14" },
  PocketFood: { src: "/assets/logos/pocketfood.png", cls: "max-h-12" },
  "Cooked Indoors": { src: "/assets/logos/cookedindoors.png", cls: "max-h-16" },
  FitPrep: { src: "/assets/logos/fitprep.png", cls: "max-h-11" },
  "Healthy Cooking Masterclass": { src: "/assets/logos/hcm.png", cls: "max-h-16", bg: "#264122" },
  ChroniCare: { src: "/assets/logos/chronicare.png", cls: "max-h-16", bg: "#454649" },
};
